export enum GetTeamTypes {
  SEARCH_TEAMS_CONFIG = '[TEAMS] Search TEAMS',
  SEARCH_TEAMS_CONFIG_SUCCESS = '[TEAMS] Search TEAMS Success',
  SEARCH_TEAMS_CONFIG_ERROR = '[TEAMS] Search TEAMS Error',
}

type GetTeamsConfiguration = {
  type: typeof GetTeamTypes.SEARCH_TEAMS_CONFIG;
};
type GetTeamsConfigurationSuccess = {
  type: typeof GetTeamTypes.SEARCH_TEAMS_CONFIG_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type GetTeamsConfigurationError = {
  type: typeof GetTeamTypes.SEARCH_TEAMS_CONFIG_ERROR;
  payload: { error: string };
};

export type TeamActionTypes =
  | GetTeamsConfiguration
  | GetTeamsConfigurationSuccess
  | GetTeamsConfigurationError;

export const teamActionsTypes = {
  getTeamsInfo: (): GetTeamsConfiguration => ({
    type: GetTeamTypes.SEARCH_TEAMS_CONFIG,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTeamsInfoSuccess: (data: any[]): GetTeamsConfigurationSuccess => ({
    type: GetTeamTypes.SEARCH_TEAMS_CONFIG_SUCCESS,
    payload: { data },
  }),
  getTeamsInfoError: (error: string): GetTeamsConfigurationError => ({
    type: GetTeamTypes.SEARCH_TEAMS_CONFIG_ERROR,
    payload: { error },
  }),
};
